import { render, staticRenderFns } from "./BusinessNameDataUpdateDetailsMessages.vue?vue&type=template&id=59e9f8ea&scoped=true&"
import script from "./BusinessNameDataUpdateDetailsMessages.vue?vue&type=script&lang=js&"
export * from "./BusinessNameDataUpdateDetailsMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e9f8ea",
  null
  
)

export default component.exports